<script src="//unpkg.com/v-viewer/dist/v-viewer.js"></script>

<template>
  <div>
    <div v-if="loading || !formLoaded">
      <span class="spinner"></span>
    </div>
    <div v-if="!loading && formLoaded">
      <b-form
        @submit.stop.prevent="onSubmit"
        :class="{
          'p-3 box-shadow2 rounded': !isDarkMode,
          'dark-div p-3 box-shadow2 rounded': isDarkMode
        }"
      >
        <b-row> </b-row>
        <b-row>
          <b-col>
            <b-form-group id="group-products" label-for="input-products">
              <template v-slot:label>
                Store Id
                <span class="text-danger">*</span>
              </template>
              <b-form-select
                v-model="form.storeid"
                :disabled="isUpdateForm"
                placeholder="Select Store Ids"
                label="text"
                :options="stores"
                :class="{
                  'box-shadow3 bg-light text': !isDarkMode,
                  darkMode: isDarkMode
                }"
              >
              </b-form-select>
              <b-form-invalid-feedback id="input-store-invalid">Please select a Store Id.</b-form-invalid-feedback>
            </b-form-group></b-col
          >
          <b-col>
            <b-col>
              <b-form-group id="group-rtvNumber" label-for="input-rtvNumber">
                <template v-slot:label>
                  Select RTV Number
                  <span class="text-danger">*</span>
                </template>
                <b-form-input
                  :class="{
                    'box-shadow3 bg-light text-dark': !isDarkMode,
                    'bg-dark text-light placeholder-light': isDarkMode
                  }"
                  id="input-vendorCode"
                  type="number"
                  v-model="form.rtvNumber"
                  placeholder="Enter Article Code"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12" lg="6">
            <b-form-group id="group-rtvDate" label-for="input-rtvDate">
              <template v-slot:label>
                Rtv Date
                <span class="text-danger">*</span>
              </template>
              <b-row>
                <b-col>
                  <b-input-group class="box-shadow2 mb-2">
                    <b-input-group-append>
                      <b-form-datepicker
                        button-only
                        id="input-rtvDate"
                        placeholder="Select Date"
                        :max="maxDate"
                        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                        v-model="form.rtvDate"
                        :disabled="isUpdateForm"
                        class="box-shadow3"
                      ></b-form-datepicker>
                    </b-input-group-append>
                    <b-form-input
                      id="input-rtvDate"
                      v-model="form.rtvDate"
                      type="text"
                      placeholder="Select Date"
                      autocomplete="off"
                      :class="{
                        '': !isDarkMode,
                        'bg-dark text-light placeholder-light': isDarkMode
                      }"
                      disabled
                    ></b-form-input>
                  </b-input-group>
                </b-col>
              </b-row>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group id="group-vendorCode" label-for="input-vendorCode">
              <template v-slot:label>
                Vendor Code
                <span class="text-danger">*</span>
              </template>

              <b-form-input
                :class="{
                  'box-shadow3 bg-light text-dark': !isDarkMode,
                  'bg-dark text-light placeholder-light': isDarkMode
                }"
                id="input-vendorCode"
                type="text"
                v-model="form.vendorCode"
                placeholder="Enter Article Code"
              ></b-form-input>
              <!--:disabled="isUpdateForm"-->
            </b-form-group></b-col
          >
        </b-row>

        <b-row>
          <b-col>
            <b-form-group id="group-articleCode" label-for="input-articleCode">
              <template v-slot:label>
                Article Code
                <span class="text-danger">*</span>
              </template>

              <b-form-input
                :class="{
                  'box-shadow3 bg-light text-dark': !isDarkMode,
                  'bg-dark text-light placeholder-light': isDarkMode
                }"
                id="input-articleCode"
                type="number"
                v-model="form.articleCode"
                placeholder="Enter Article Code"
              ></b-form-input>
              <!--:disabled="isUpdateForm"-->
            </b-form-group></b-col
          >
          <b-col>
            <b-form-group id="group-articleDescription" label-for="input-articleDescription">
              <template v-slot:label>
                Article description
                <span class="text-danger">*</span>
              </template>
              <b-form-input
                :class="{
                  'box-shadow3 bg-light text-dark': !isDarkMode,
                  'bg-dark text-light placeholder-light': isDarkMode
                }"
                id="input-articleDescription"
                type="text"
                v-model="form.articleDescription"
                placeholder="Enter Article description"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-form-group id="group-rtvQuantity" label-for="input-rtvQuantity">
              <template v-slot:label>
                RTV Quantity
                <span class="text-danger">*</span>
              </template>
              <b-form-input
                :class="{
                  'box-shadow3 bg-light text-dark': !isDarkMode,
                  'bg-dark text-light placeholder-light': isDarkMode
                }"
                id="input-rtvQuantity"
                type="number"
                v-model="form.rtvQuantity"
                placeholder="Enter RTV Quantity"
              ></b-form-input>
              <b-form-invalid-feedback id="input-name-invalid"
                >Please enter Transaction amount.</b-form-invalid-feedback
              >
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group id="group-physicalQuantity" label-for="input-physicalQuantity">
              <template v-slot:label>
                Physical Quantity
                <span class="text-danger">*</span>
              </template>

              <b-form-input
                :class="{
                  'box-shadow3 bg-light text-dark': !isDarkMode,
                  'bg-dark text-light placeholder-light': isDarkMode
                }"
                id="input-physicalQuantity"
                type="number"
                v-model="form.physicalQuantity"
                placeholder="Enter Number"
              ></b-form-input>

              <b-form-invalid-feedback id="input-name-invalid"
                >Customer Mobile number must be 10 digit long.</b-form-invalid-feedback
              >
            </b-form-group></b-col
          >
        </b-row>

        <b-row>
          <b-col
            ><b-form-group id="group-currentStatus" label-for="input-currentStatus">
              <template v-slot:label>
                Select Status
                <span class="text-danger">*</span>
              </template>
              <b-form-select
                v-model="form.currentStatus"
                id="input-currentStatus"
                placeholder="Select"
                label="text"
                :options="statusType"
                :class="{
                  'box-shadow3 bg-light text': !isDarkMode,
                  darkMode: isDarkMode
                }"
              >
              </b-form-select>
              <b-form-invalid-feedback id="input-store-invalid">Please select a Store Id.</b-form-invalid-feedback>
            </b-form-group>
          </b-col>

          <b-col>
            <b-form-group id="group-rtvValue" label-for="input-rtvValue">
              <template v-slot:label>
                RTV Value
                <span class="text-danger">*</span>
              </template>

              <b-form-input
                :class="{
                  'box-shadow3 bg-light text-dark': !isDarkMode,
                  'bg-dark text-light placeholder-light': isDarkMode
                }"
                id="input-rtvValue"
                type="number"
                v-model="form.rtvValue"
                placeholder="Enter Number"
              ></b-form-input>

              <b-form-invalid-feedback id="input-name-invalid"
                >Customer Mobile number must be 10 digit long.</b-form-invalid-feedback
              >
            </b-form-group></b-col
          >
        </b-row>
        <b-row>
          <b-col sm="12" lg="6">
            <b-form-group id="group-dateOfPickUp" label-for="input-dateOfPickUp">
              <template v-slot:label>
                Date of Pickup
                <span class="text-danger">*</span>
              </template>
              <b-row>
                <b-col>
                  <b-input-group class="box-shadow2 mb-2">
                    <b-input-group-append>
                      <b-form-datepicker
                        button-only
                        id="start-datepicker"
                        placeholder="Select Date"
                        :max="maxDate"
                        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                        v-model="form.dateOfPickUp"
                        :disabled="isUpdateForm"
                        class="box-shadow3"
                      ></b-form-datepicker>
                    </b-input-group-append>
                    <b-form-input
                      id="example-input"
                      v-model="form.dateOfPickUp"
                      type="text"
                      placeholder="Select Date"
                      autocomplete="off"
                      :class="{
                        '': !isDarkMode,
                        'bg-dark text-light placeholder-light': isDarkMode
                      }"
                      disabled
                    ></b-form-input>
                  </b-input-group>
                </b-col>
              </b-row>
            </b-form-group>
          </b-col>
          <b-col sm="12" lg="6">
            <b-form-group id="group-dateOfDispatch" label-for="input-dateOfDispatch">
              <template v-slot:label>
                Date of Dispatch
                <span class="text-danger">*</span>
              </template>
              <b-row>
                <b-col>
                  <b-input-group class="box-shadow2 mb-2">
                    <b-input-group-append>
                      <b-form-datepicker
                        button-only
                        id="input-dateOfDispatch"
                        placeholder="Select Date"
                        :max="maxDate"
                        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                        v-model="form.dateOfDispatch"
                        :disabled="isUpdateForm"
                        class="box-shadow3"
                      ></b-form-datepicker>
                    </b-input-group-append>
                    <b-form-input
                      id="input-dateOfDispatch"
                      v-model="form.dateOfDispatch"
                      type="text"
                      placeholder="Select Date"
                      autocomplete="off"
                      :class="{
                        '': !isDarkMode,
                        'bg-dark text-light placeholder-light': isDarkMode
                      }"
                      disabled
                    ></b-form-input>
                  </b-input-group>
                </b-col>
              </b-row>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <div v-viewer>
              <b-form-group id="group-products" label-for="input-products">
                <template v-slot:label>
                  {{ isUpdateForm ? 'Uploaded RTV Document' : 'Upload RTV Document' }}
                  <span class="text-danger">*</span>
                </template>
                <input v-if="!isUpdateForm" type="file" @change="uploadFile($event, 'rtvDocumentUrl')" />
                <div v-if="form.rtvDocumentUrl" class="mt-2 imageView">
                  <img
                    :src="form.rtvDocumentUrl"
                    alt="Preview Image"
                    class="mx-2"
                    style="width: 120px; height: 120px"
                  />
                  <link href="//unpkg.com/viewerjs/dist/viewer.css" rel="stylesheet" />
                </div>
                <b-row>
                  <b-form-text v-if="!form.rtvDocumentUrl" id="input-role-help">
                    Note: RTV Document uploaded along with the promoter and vendor repersentative signature
                  </b-form-text>
                </b-row>
              </b-form-group>
            </div>
          </b-col>
          <b-col>
            <div v-viewer>
              <b-form-group id="group-products" label-for="input-products">
                <template v-slot:label>
                  {{ isUpdateForm ? 'Uploaded Singature' : 'Upload Singature' }}
                  <span class="text-danger">*</span>
                </template>
                <input v-if="!isUpdateForm" type="file" @change="uploadFile($event, 'passoutSlipUrl')" />
                <div v-if="form.passoutSlipUrl" class="mt-2 imageView">
                  <img
                    :src="form.passoutSlipUrl"
                    alt="Preview Image"
                    class="mx-2"
                    style="width: 120px; height: 120px"
                  />
                  <link href="//unpkg.com/viewerjs/dist/viewer.css" rel="stylesheet" />
                </div>
                <b-row>
                  <b-form-text v-if="!form.passoutSlipUrl" id="input-role-help">
                    Note: Passout slip with the document details and vehicle number and sign of the vendor
                  </b-form-text>
                </b-row>
              </b-form-group>
            </div>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col>
            <div v-viewer>
              <b-form-group id="group-products" label-for="input-products">
                <template v-slot:label>
                  {{ isUpdateForm ? 'Uploaded POD' : 'Upload POD' }}
                  <span class="text-danger">*</span>
                </template>
                <input v-if="!isUpdateForm" type="file" @change="uploadFile($event, 'courierPodUrl')" />
                <div v-if="form.courierPodUrl" class="mt-2 imageView">
                  <img :src="form.courierPodUrl" alt="Preview Image" class="mx-2" style="width: 120px; height: 120px" />
                  <link href="//unpkg.com/viewerjs/dist/viewer.css" rel="stylesheet" />
                </div>
                <b-row>
                  <b-form-text v-if="!form.courierPodUrl" id="input-role-help">
                    Note: (if Courier Pickup),Courier POD Copy Attachment
                  </b-form-text>
                </b-row>
              </b-form-group>
            </div>
          </b-col>
          <b-col cols="6" mt-4 class="ml-3">
            <b-row>
              <b-form-checkbox v-model="form.isVerified"> Is Verified by SM/Tl </b-form-checkbox>
            </b-row>
            <b-row> </b-row>
          </b-col>
        </b-row>
        <!-- Button Section -->
        <b-form-group>
          <b-row class="mt-2">
            <b-col class="text-right">
              <b-button
                class="box-shadow2 mr-2"
                size="sm"
                :variant="isDarkMode ? 'outline-success' : 'success'"
                type="submit"
                :disabled="loading"
              >
                <span class="spinner spinner-white" v-if="loading"></span>
                <font-awesome-icon :icon="['fas', 'save']" class="mr-1" />Submit
              </b-button>

              <b-button
                v-if="isUpdateForm && (form.rtvDocumentUrl || form.passoutSlipUrl || form.courierPodUrl)"
                class="box-shadow2 mr-2"
                size="sm"
                :variant="isDarkMode ? 'outline-info' : 'info'"
                @click="downloadAllImages"
                :disabled="downloading"
              >
                <span class="spinner spinner-white" v-if="downloading"></span>
                <font-awesome-icon :icon="['fas', 'download']" class="mr-1" />Download Images
              </b-button>

              <b-button
                class="ml-2 box-shadow2"
                size="sm"
                :variant="isDarkMode ? 'outline-warning' : 'warning'"
                :to="{ path: `/eneTracker` }"
              >
                <font-awesome-icon :icon="['fas', 'long-arrow-alt-left']" class="mr-1" />Back to list
              </b-button>
            </b-col>
          </b-row>
        </b-form-group>
      </b-form>
    </div>
  </div>
</template>

<script>
import { required, maxLength, minLength } from 'vuelidate/lib/validators';
import moment from 'moment';
import { mapGetters, mapState, mapActions } from 'vuex';
import configService from '@/services/configService';
import router from '@/router';
import Multiselect from 'vue-multiselect';
import VueViewer from 'v-viewer';
import Vue from 'vue';

Vue.use(VueViewer);
export default {
  name: 'TransactionFrom',
  components: {
    Multiselect
  },
  props: {
    listUrl: String,
    formType: String,
    documentType: String,
    loading: Boolean
  },
  metaInfo() {
    return {
      meta: [
        {
          name: 'description',
          content: this.metaDescription
        }
      ]
    };
  },
  data() {
    return {
      inputs: [
        {
          name: ''
        }
      ],
      downloading: false,
      formLoaded: true,
      storeid: '',
      stores: [],
      complainNumberSharedByBrand: '',
      statusType: [
        { value: null, text: 'Select Status' },
        { value: 'VENDOR_PICKUP', text: 'Vendor Pickup' },
        { value: 'COURIER_DISPATCH', text: 'Courier Dispatch' }
      ],
      statusTypes: [
        { value: null, text: 'Select' },
        { value: 'PENDING', text: 'Pending' },
        { value: 'RESOLVED', text: 'Resolved' },
        { value: 'NOT_RESOLVED', text: 'Not Resolved' }
      ],
      rtvNumberOptions: [1, 2, 3, 4, 5, 56],
      currentStatus: '',
      form: {
        rtvDate: moment().format('YYYY-MM-DD'),
        rtvNumber: null,
        rtvNumberB: 1,
        articleCode: '',
        articleDescription: '',
        vendorCode: '',
        rtvQuantity: '',
        rtvValue: '',
        isVerified: false,
        physicalQuantity: '',
        currentStatus: null,
        dateOfPickUp: moment().format('YYYY-MM-DD'),
        rtvDocumentUrl: '',
        passoutSlipUrl: '',
        courierPodUrl: '',
        dateOfDispatch: moment().format('YYYY-MM-DD'),
        storeid: '',
        file: [],
        fileName: []
      },
      maxDate: moment().format('YYYY-MM-DD'),
      dateTimeFormat: configService.get('format').pickerDateTime,
      complainDateWithBrand: moment().format('YYYY-MM-DD'),
      invoiceDate: moment().format('YYYY-MM-DD'),
      imagePreview: null
    };
  },
  validations() {
    const formValidation = {
      customerName: {
        required
      },
      customerMobileNumber: {
        required,
        maxLength: maxLength(10),
        minLength: minLength(10)
      },
      smMobile: {
        required,
        validateMobileNumbers(value) {
          if (!value) return false;
          const numbers = value.split(',').map(num => num.trim());
          return numbers.every(num => /^\d{10}$/.test(num));
        }
      },

      transactionId: {
        required
      },
      transactionAmount: {
        required
      },
      complainDateWithBrand: {
        required
      }
      // approverRemarks: {
      //   required: this.formType === 'update'
      // }
    };

    if (this.formType === 'new') {
      formValidation.customerName.required = required;
      formValidation.customerMobileNumber.required = required;
      formValidation.smMobile.required = required;
      formValidation.transactionId.required = required;
      formValidation.transactionAmount.required = required;
    }

    return { form: formValidation };
  },
  mounted() {
    this.getStoreByUser({ router });

    this.$nextTick(async () => {
      if (this.formType === 'new') {
        this.formLoaded = true;
        this.$v.$touch();
        this.$v.$reset();
      }
    });
  },
  computed: {
    metaDescription() {
      return this.formType === 'new' ? 'Add new Transaction Complain' : 'Update Transaction Complain';
    },
    isUpdateForm() {
      return this.formType === 'update';
    },
    isDisable() {
      return this.currentStatus === 'IN PROGRESS';
    },
    ...mapGetters('alert', ['errorMessages']),
    ...mapState('darkMode', ['isDarkMode']),
    ...mapState('auth', ['user']),
    ...mapState('cstSubmission', ['store']),
    ...mapState('rtv', ['baseUrl', 'pagination', 'oneRtv', 'complain', 'images', 'uploadedImages'])
  },
  methods: {
    ...mapActions('rtv', ['getOne', 'postOne', 'patchOne', 'uploadImage']),
    ...mapState('rtv', ['baseUrl', 'pagination', 'oneRtv', 'complain', 'images']),
    ...mapActions('cstSubmission', ['getStoreByUser']),
    async downloadAllImages() {
      this.downloading = true;
      const images = [
        { url: this.form.rtvDocumentUrl, name: 'RTV_Document' },
        { url: this.form.passoutSlipUrl, name: 'Passout_Slip' },
        { url: this.form.courierPodUrl, name: 'Courier_POD' }
      ].filter(img => img.url);

      for (const image of images) {
        try {
          const response = await fetch(image.url);
          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = `${image.name}_${this.form.rtvNumber}.jpg`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
          await new Promise(resolve => setTimeout(resolve, 500));
        } catch (error) {
          console.error(`Failed to download ${image.name}:`, error);
        }
      }
      this.downloading = false;
    },
    handleButtonDisable() {
      if (this.formType === 'new' && this.ifStoreManager()) {
        return true;
      } else if (this.ifFinanceAdmin() && (this.currentStatus === 'IN PROGRESS' || this.currentStatus === 'CREATED')) {
        return true;
      }
      return false;
    },
    ifAdmin() {
      const isAdmin = this.user.roles.filter(role => role.name === 'ADMIN');
      if (isAdmin.length) {
        return true;
      }
      return false;
    },
    ifStoreManager() {
      const isStoreManager = this.user.roles.filter(role => role.name === 'STORE_SALES_MANAGER');
      if (isStoreManager.length) {
        return true;
      }
      return false;
    },
    ifFinanceAdmin() {
      const isAdmin = this.user.roles.filter(role => role.name === 'FINANCE_ADMIN');
      if (isAdmin.length) {
        return true;
      }
      return false;
    },
    validateSMMobile(value) {
      if (value && value.toString().length > 10) {
        this.form.smMobile = value.toString().slice(0, 10);
      }
    },
    validateCustomerPhone(value) {
      // the use case
      //                @input="validateCustomerPhone"
      if (value && value.toString().length > 10) {
        this.form.customerMobileNumber = value.toString().slice(0, 10);
      }
    },
    uploadFile(event, urlName) {
      let allAreImages = true;
      this.form.file = [];

      if (event.target.files && event.target.files.length > 0) {
        for (let i = 0; i < event.target.files.length; i++) {
          const file = event.target.files[i];
          if (!file || !file.type.includes('image')) {
            allAreImages = false;
            event.target.value = '';
            alert('Only image files are allowed.');
            break;
          }
        }

        if (allAreImages) {
          for (let i = 0; i < event.target.files.length; i++) {
            const file = event.target.files[i];
            if (file) {
              this.form.file.push(file);

              const reader = new FileReader();
              reader.onload = e => {
                if (!this.imagePreview) {
                  this.imagePreview = [];
                }
                this.imagePreview.push(e.target.result);
              };
              reader.readAsDataURL(file);
            }
          }
          this.form.file.forEach(file => {
            if (file) {
              this.uploadImage({ file, urlName }, {}, router);
            }
          });
        }
      }
    },
    onSubmit() {
      //      this.$v.$touch();
      //      if (this.$v.$invalid) {
      //        return false;
      //      }
      const rtv = {
        rtvDate: this.form.rtvDate,
        rtvNumber: Number(this.form.rtvNumber),
        vendorCode: this.form.vendorCode,
        rtvQuantity: Number(this.form.rtvQuantity),
        rtvValue: Number(this.form.rtvValue),
        isVerified: this.form.isVerified,
        physicalQuantity: Number(this.form.physicalQuantity),
        currentStatus: this.form.currentStatus,
        dateOfPickUp: this.form.dateOfPickUp,
        rtvDocumentUrl: this.form.rtvDocumentUrl,
        passoutSlipUrl: this.form.passoutSlipUrl,
        courierPodUrl: this.form.courierPodUrl,
        dateOfDispatch: this.form.dateOfDispatch,
        articleCode: this.form.articleCode,
        articleDescription: this.form.articleDescription,
        storeid: this.form.storeid,
        file: [],
        fileName: []
      };
      if (this.formType === 'new') {
        this.$emit('add', { rtv });
      } else {
        this.$emit('edit', { rtv });
      }
      return false;
    },
    addTag(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000)
      };
      this.options.push(tag);
      this.value.push(tag);
      setTimeout(() => {
        this.$refs.multiselect.$refs.search.focus();
      }, 100);
    }
  },
  watch: {
    uploadedImages(newValue) {
      if (newValue) {
        this.form.rtvDocumentUrl = newValue?.rtvDocumentUrl || '';
        this.form.passoutSlipUrl = newValue.passoutSlipUrl || '';
        this.form.courierPodUrl = newValue.courierPodUrl || '';
      }
    },
    oneRtv(newValue) {
      if (newValue.id !== '') {
        this.form.rtvDate = newValue.rtvDate;
        this.form.rtvQuantity = newValue.rtvQuantity;
        this.form.articleDescription = newValue.articleDescription;
        this.form.articleCode = newValue.articleCode;
        this.form.rtvNumber = newValue.rtvNumber;
        this.form.vendorCode = newValue.vendorCode;
        this.form.physicalQuantity = newValue.physicalQuantity;
        this.form.currentStatus = newValue.currentStatus;
        this.form.rtvValue = newValue.rtvValue;
        this.form.dateOfPickUp = newValue.dateOfPickUp;
        this.form.dateOfDispatch = newValue.dateOfDispatch;
        this.form.isVerified = newValue.isVerified;
        this.form.rtvDocumentUrl = newValue.rtvDocumentUrl;
        this.form.passoutSlipUrl = newValue.passoutSlipUrl;
        this.form.courierPodUrl = newValue.courierPodUrl;
        this.form.storeid = newValue.storeid;
      }
    },
    store(newValue) {
      if (newValue.length === 1) {
        this.storeids = newValue[0].storeid;
      }
      this.stores = [
        { text: 'Select Store ID', value: '' },
        ...newValue.map(store => ({
          text: `${store.storeName} (${store.storeid})`,
          value: store.storeid
        }))
      ];
    },

    images(newValue) {
      if (newValue !== null && newValue.length > 0) {
        this.file = newValue;
      }
    },
    user(newValue) {}
  }
};
</script>
<style src="vue-search-select/dist/VueSearchSelect.css"></style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.calender {
  display: flex;
  width: auto;
  margin-left: -9px;
  margin-bottom: 0.7rem;
}

.date {
  margin-left: -10px;
}

.upload {
  margin-top: 8px;
}

.videoPlayer {
  width: 25%;
}
</style>
<style scoped>
.textarea-height {
  height: 40px;
  /* Set your desired height here */
}

.imageView {
  display: inline-flex;
  margin: 2px;
}
</style>
